/** @format */

import axios from "axios";
import React, { useEffect, useState } from "react";

import { header } from "../../../../../components/api/Header";
import PieChart2 from "../../../../../components/Charts/PieChart2";
import BarChart5 from "../../../../../components/Charts/BarChart5";
import LoadingCard from "../../../../../components/loading/loadingCard";
import { getEnv } from "../../../../../lib/env";

function Page1({ date }) {
  const [data, setData] = useState();
  const [loadingCard, setLoadingCard] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoadingCard(true);
      try {
        const res = await axios.get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/republik/amudaryo/graph?date=" +
            date,
          header()
        );
        setData(res.data);
      } catch (e) {
        console.log("Xato", e);
        alert("Serverga ulanishda xato");
      } finally {
        setLoadingCard(false);
      }
    };
    fetchData();
  }, [date]);

  if (loadingCard) {
    return <LoadingCard heightSize={500} loading={loadingCard} />;
  }

  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-md-6 mb-3'>
          <div className='pie-box' style={{ height: "350px" }}>
            <div className='zarafshon-chart-table'>
              <h4>Amudaryo (jami)</h4>
            </div>

            {data ? (
              <PieChart2
                d1={data["f"]["1"]}
                d2={data["f"]["2"]}
                d3={data["d"]["1"]}
                d4={data["d"]["2"]}
              />
            ) : null}
          </div>
        </div>

        <div className='col-md-6 mb-3'>
          <div className='pie-box' style={{ height: "350px" }}>
            <div className='zarafshon-chart-table'>
              <h4>Tuyamo’yin SO gacha</h4>
            </div>

            {data ? (
              <PieChart2
                d1={data["f"]["3"]}
                d2={data["f"]["4"]}
                d3={data["d"]["3"]}
                d4={data["d"]["4"]}
              />
            ) : null}
          </div>
        </div>
      </div>

      <div className='row'>
        <div className='col-md-6 mb-3'>
          <div className='pie-box' style={{ height: "350px" }}>
            <div className='zarafshon-chart-table'>
              <h4>Tuyamo’yin SO quyi qismi</h4>
            </div>

            {data ? (
              <PieChart2
                d1={data["f"]["5"]}
                d2={data["f"]["6"]}
                d3={data["d"]["5"]}
                d4={data["d"]["6"]}
              />
            ) : null}
          </div>
        </div>

        <div className='col-md-6'>
          <div
            className='pie-box _pie-box barchart-box'
            style={{ height: "350px" }}>
            <div className='zarafshon-chart-table mb-2'>
              <h4>
                Jami suv (m<sup>3</sup>/s)
              </h4>
            </div>

            {data ? <BarChart5 arr={data["v"]} /> : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Page1;
